import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SapCommunicationLogCollectionResponse, SapCommunicationLogEntry } from './sap-communication.model';
import { ApiService } from '../shared/base/api-service';

@Injectable({
  providedIn: 'root'
})
export class SapCommunicationLogService extends ApiService {

  private restApiUrl = this.apiUrl('admin/order-history-sap');

  constructor(private httpClient: HttpClient) {
    super();
  }

  public find(id: string): Observable<SapCommunicationLogEntry> {
    return this.httpClient.get<SapCommunicationLogEntry>(this.restApiUrl + '/' + id)
  }

  public findPaginated(
    page: number = 1,
    pageSize: number = 25,
    sortBy: string = 'name',
    sortDirection: string = 'desc',
    filter: string = '',
  ): Observable<SapCommunicationLogCollectionResponse> {
    const queryParams = new HttpParams()
      .append('page', page.toString())
      .append('page_size', pageSize.toString())
      .append('sort_by', sortBy)
      .append('sort_direction', sortDirection)
      .append('filter', filter.trim());

    return this.httpClient
      .get<SapCommunicationLogCollectionResponse>(this.restApiUrl, {params: queryParams})
  }
}
